import type { Action } from "../../actions/types";

export type StoreState = string;

export const initialState = "";

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState | null {
  switch (action.type) {
    case "EVENT_SUCCESS":
    case "GET_REFERRAL_SUCCESS":
    case "GET_SHARE_SUCCESS":
    case "EMAIL_SHARE_SUCCESS":
    case "ACCOUNT_CREDIT_REDEEM_SUCCESS":
    case "LOYALTY_OPTIN_SUCCESS":
    case "POLL_FOR_REWARD_SUCCESS": {
      return "SUCCESS";
    }

    case "ACCOUNT_CREDIT_REDEEM_FAILURE":
    case "EMAIL_SHARE_FAILURE":
    case "EVENT_FAILURE":
    case "EXCHANGE_REDEEM_FAILURE":
    case "GET_REFERRAL_FAILURE":
    case "GET_SHARE_FAILURE":
    case "LOYALTY_OPTIN_FAILURE":
    case "POLL_FOR_REWARD_FAILURE": {
      return "FAILURE";
    }

    case "EVENT_REQUEST":
    case "GET_REFERRAL_REQUEST":
    case "GET_SHARE_REQUEST":
    case "EMAIL_SHARE_REQUEST":
    case "ACCOUNT_CREDIT_REDEEM_REQUEST":
    case "LOYALTY_OPTIN_REQUEST":
    case "POLL_FOR_REWARD_REQUEST": {
      return "REQUESTING";
    }

    case "SET_SCREEN_NAME": {
      return "";
    }

    default:
      return state;
  }
}
